import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["FlagProvider"] */ "/app/node_modules/@unleash/nextjs/client.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/providers/MuiProvider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/providers/NotificationProvider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/providers/QueryProvider.jsx");
